import React from "react";
import { cn } from "@gettactic/helpers/src/css/cn";
import { useDataMan } from "../../hooks/useDataMan";
import { DataManColumnProvider } from "../../providers/DataManColumnProvider";

interface DataManTableViewHeaderProps {
  className?: string;
}

export const DataManTableViewHeader = React.forwardRef<
  HTMLTableSectionElement,
  DataManTableViewHeaderProps
>(({ className }, ref) => {
  const {
    hasSortableDataColumns,
    hasBulkSelection,
    viewModeOptions,
    visibleColumns,
    hasActions
  } = useDataMan();
  const columns = visibleColumns || [];
  return (
    <thead className={cn("relative z-[9] bg-[#F7F9FB]", className)} ref={ref}>
      <tr>
        {hasSortableDataColumns && (
          <DataManColumnProvider isSortableHandler>
            {React.createElement(viewModeOptions.ColumnTitle)}
          </DataManColumnProvider>
        )}
        {hasBulkSelection && (
          <DataManColumnProvider isSelectionColumn>
            {React.createElement(viewModeOptions.ColumnTitle)}
          </DataManColumnProvider>
        )}
        {columns.map((column, index) => {
          const isLastColumn = !hasActions && index === columns.length - 1;
          return (
            <DataManColumnProvider
              column={column}
              isOptionsColumn={isLastColumn}
              key={column.key}
            >
              {React.createElement(viewModeOptions.ColumnTitle)}
            </DataManColumnProvider>
          );
        })}
        {hasActions && (
          <DataManColumnProvider isOptionsColumn isActionColumn>
            {React.createElement(viewModeOptions.ColumnTitle)}
          </DataManColumnProvider>
        )}
      </tr>
    </thead>
  );
});

DataManTableViewHeader.displayName = "DataManTableViewHeader";
